import { Fragment } from 'react';
import UserFirstProfile from './UserFirstProfile';
import UserSecondProfile from './UserSecondProfile';
import UserThirdProfile from './UserThirdProfile';
import UserFourthProfile from './UserFourthProfile';
import UserFifthProfile from './UserFifthProfile';


export default function TourMain() {
  return (
    <Fragment>
        <UserFirstProfile/>
        <UserSecondProfile/>
        <UserThirdProfile/>
        <UserFourthProfile/>
        <UserFifthProfile/>
    </Fragment>
  )
}
